import api from './api';
import {
  ApiResponse,
  ForgotPasswordRequest,
  LoginRequest,
  LoginResponse,
  ResetPasswordRequest,
} from '../types';

export const authService = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>('/auth/login', data);
    return response.data;
  },

  cadastrar: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>('/auth/cadastrar', data);
    return response.data;
  },

  forgotPassword: async (email: string): Promise<string> => {
    const data: ForgotPasswordRequest = { email };
    const response = await api.post<ApiResponse<void>>('/auth/forgot-password', data);
    return response.data.mensagem;
  },

  resetPassword: async (data: ResetPasswordRequest): Promise<string> => {
    const response = await api.post<ApiResponse<void>>('/auth/reset-password', data);
    return response.data.mensagem;
  },
};
